import { FormControl as MUIFormControl } from '@mui/material';

/**
 * Project alias for MUI's FormControl. Import from here instead of
 * `@mui/material` so the whole app tracks one implementation. All MUI
 * FormControl props pass through.
 */
const FormControl = props => <MUIFormControl {...props} />;

export default FormControl;
